<template>
    <div>
      <div class="content-wrappper">
        <div class="row mr-0 ml-0">
          <div class="col-xs-12 col-sm-12 p-15">
            <div class="col-lg-offset-5 col-md-offset-4 col-sm-offset-3 col-xs-offset-0 sx-align-right" v-if="enableAddRole">
              <button type="button" class="btn emergo-white-button margin" @click="marketPlaceServices">
                <img src="/static/images/icons/marketplace_service_icon.svg" class="tracker-images" alt="marketplace-icon"/>
                <span class="text-color-blue">Master Services</span>
              </button>
            <button type="button" class="btn emergo-white-button margin" @click="addRoleTemplate">
              <img src="/static/images/icons/profile_icon.svg" class="tracker-images" alt="profile-icon"/>
              <span class="text-color-blue">Import Role Template</span>
            </button>
            <button type="button" class="btn emergo-green-button margin" @click="addRole"><i class="fa fa-plus"></i> Add Role</button>
            </div>
            <div class="col-sm-offset-9 col-xs-offset-4" v-else>
              <button type="button" class="btn emergo-white-button" @click="addRoleTemplate">
                <img src="/static/images/icons/profile_icon.svg" class="tracker-images" alt="profile-icon"/>
                <span class="text-color-blue">Import Role Template</span>
              </button>
            </div>
          </div>
        </div>
      <RBACGrid @uploadType="uploadType"></RBACGrid>
      <rbac-add-role-modal :type="type" :header="header" :roleInfo="roleData" @uploadJsonModal="rbacUploadJSONPopup"></rbac-add-role-modal>
      <rbac-upload-json-modal :type="type" :selectedRoleIdToUpload="selectedRoleIdToUpload" @openAddRolePopup="addRolePopup"/>
      <rbac-mrkt-place-services-modal />
      </div>
    </div>
</template>
<script>
import $ from 'jquery';
import RBACGrid from './RBACGrid.vue';
import RBACAddRoleModal from './RBACAddRoleModal.vue';
import RBACUploadJsonModal from './RBACUploadJsonModal.vue';
import RBACMrktPlaceServicesModal from './RBACServices/RBACMrktPlaceServicesModal.vue';

export default {
  components: {
    RBACGrid,
    'rbac-mrkt-place-services-modal': RBACMrktPlaceServicesModal,
    'rbac-upload-json-modal': RBACUploadJsonModal,
    'rbac-add-role-modal': RBACAddRoleModal,
  },
  data() {
    return {
      header: '',
      type: '',
      roleData: {},
      selectedRoleIdToUpload: '',
      enableAddRole: false,
    };
  },
  created() {
    if (window.location.hostname === 'localhost' || window.location.hostname === 'dev.rams.emergobyul.com') {
      this.enableAddRole = true;
    }
  },
  methods: {
    marketPlaceServices() {
      $('#RBACMrktPlaceServicesModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    addRolePopup(roleData) {
      this.roleData = roleData;
      $('#addNewRoleModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    rbacUploadJSONPopup() {
      $('#rbacUploadJson').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    uploadType(type, selectedRoleId) {
      this.type = type;
      this.header = 'Import Role';
      this.selectedRoleIdToUpload = selectedRoleId;
      this.rbacUploadJSONPopup();
    },
    addRoleTemplate() {
      this.type = 'new_role_template';
      this.header = 'Import Role Template';
      this.rbacUploadJSONPopup();
    },
    addRole() {
      this.type = 'new_role';
      this.header = 'Add Role';
      $('#addNewRoleModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.margin{
  margin-left: 10px;
}
.tracker-images {
	width: 18px;
	height: 18px;
	margin-right: 4px;
	vertical-align: top;
	margin-top: 1px;
}
@media screen and (max-width:410px) {
 .margin{
    margin: 10px 0px 0px 35px;
    padding: 6px 25px;
  }
}
@media screen and (min-width: 768px){
  .sx-align-right{
    text-align: right;
  }
}
</style>
